import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { SessionService } from '@services/session.service';

export const mobileRedirectGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const isMobile = inject(BreakpointObserver).isMatched([Breakpoints.Handset]);
  const navigateToPlay = inject(SessionService).sessionParams.navigateToPlay;

  let path: string;
  if (isMobile && navigateToPlay) {
    path = '/m/game';
  } else {
    path = isMobile ? '/m' : '/d';
  }

  return inject(Router).navigate([path], { queryParams: route.queryParams });
};
